"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiVideosClient = void 0;
const VideoSearchResultsConverter_1 = require("../model/VideoSearchResultsConverter");
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const VideosConverter_1 = require("../model/VideosConverter");
const CaptionsConverter_1 = require("../model/CaptionsConverter");
const TranscriptConverter_1 = require("../model/TranscriptConverter");
class ApiVideosClient extends ApiSubClient_1.ApiSubClient {
    async get(id, referer) {
        const videoLink = this.getLinkOrThrow('video');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(videoLink.href, { id, referer }));
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async getVideoProjection(video, projection) {
        const link = video._links[projection]?.getOriginalLink();
        if (!link) {
            throw Error(`Projection ${projection} not available in these links`);
        }
        const response = await this.axios.get(link);
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async search(searchRequest) {
        const link = this.getLinkOrThrow('searchVideos');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(link.href, { ...searchRequest }));
        return VideoSearchResultsConverter_1.VideoSearchResultsConverter.convert(response.data);
    }
    async update(id, updateVideoRequest) {
        const videoLink = this.getLinkOrThrow('video');
        const response = await this.axios.patch((0, expandUrlTemplate_1.default)(videoLink.href, { id }), updateVideoRequest);
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async updateCaptions(id, updateCaptionsRequest) {
        const captionsLink = this.getLinkOrThrow('getCaptions');
        return await this.axios.put((0, expandUrlTemplate_1.default)(captionsLink.href, { id }), updateCaptionsRequest);
    }
    async getCaptions(id) {
        const captionsLink = this.getLinkOrThrow('getCaptions');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(captionsLink.href, { id }));
        return CaptionsConverter_1.CaptionsConverter.convert(response.data);
    }
    async deleteThumbnail(video) {
        const link = video.playback.links?.deleteThumbnail;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.delete(link.getOriginalLink());
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async getRecommendations(video) {
        const link = video.links?.recommendations;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.get(link.getOriginalLink());
        return response.data.recommendations
            ? response.data.recommendations.map((it) => VideosConverter_1.VideosConverter.convert(it))
            : [];
    }
    async createEmbedCode(video, segmentStart, segmentEnd) {
        const link = video.links?.createEmbedCode;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.post(link.getOriginalLink(), {
            segmentStart: segmentStart,
            segmentEnd: segmentEnd,
        });
        return response.data;
    }
    async setThumbnailBySecond(video, second) {
        const link = video.playback.links?.setThumbnailBySecond;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.patch(link.getTemplatedLink({ thumbnailSecond: second }));
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async setCustomThumbnail(video, file) {
        const formData = new FormData();
        formData.append('thumbnailImage', file);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        const customThumbnailLink = video.playback.links?.setCustomThumbnail;
        if (!customThumbnailLink)
            throw new Error(`Not authorized`);
        const response = await this.axios.post(customThumbnailLink.getTemplatedLink({ playbackId: video.playback.id }), formData, config);
        return VideosConverter_1.VideosConverter.convert(response.data);
    }
    async updateFromCsv(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        const link = this.getLinkOrThrow('updateVideos');
        if (!link)
            throw new Error(`Not authorized`);
        return this.axios
            .patch(link.href, formData, config)
            .then((response) => response.data.message)
            .catch((error) => Promise.reject(error.message));
    }
    getTranscript(video) {
        const transcriptLink = video.links?.transcript;
        if (!transcriptLink)
            throw new Error(`Not authorized`);
        return this.axios.get(transcriptLink.getOriginalLink()).then((response) => {
            const disposition = response.headers['content-disposition'];
            const filename = TranscriptConverter_1.TranscriptConverter.GenerateFilename(disposition, video.title);
            const content = response.data;
            return Promise.resolve({ content, filename });
        });
    }
}
exports.ApiVideosClient = ApiVideosClient;
//# sourceMappingURL=ApiVideosClient.js.map